<template>
  
    <table class="lytable" :style="{height:height+'px'}">
      <thead ref="thead">
        <tr>
          <td
            :style="{ width: x.width ? x.width + 'px' : '' }"
            v-for="(x, index) in columns"
            :key="index"
          >
            <template v-if="x.title">{{ x.title }}</template>
            <template v-else>#</template>
          </td>
        </tr>
      </thead>
      <tbody ref="tbody">
        <tr v-for="(y, index1) in tableData" :key="index1">
          <td
            :style="{ width: x.width ? x.width + 'px' : '' }"
            v-for="(x, index) in columns"
            :key="index"
          >
            <template v-if="x.type == 'index'">{{ index1 + 1 }}</template>
            <template v-if="x.key">{{ y[x.key] }}</template
            ><slot
              v-if="x.slot"
              :name="x.slot"
              :row="tableData[index]"
              :index="index1"
            ></slot>
          </td>
        </tr>
      </tbody>
    </table>
</template>
<script>
export default {
  props: ["data", "columns", "height"],
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    tongbu() {
      const thead = this.$refs.thead;
      const tbody = this.$refs.tbody;
      tbody.addEventListener("scroll", function (e) {
        thead.scrollLeft = tbody.scrollLeft;
      });
    },
  },
  watch: {
    data(v) {
      this.tableData = v;
    },
  },
  mounted() {
    this.tongbu();
  },
};
</script>
<style>

.lytable {
  padding: 0px;
  height: calc(100% - 20px);
  margin-bottom: 20px;
  width: 100%;
  display: block;
}
.lytable tr {
  width: 100%;
}
.lytable th {
  line-height: 3;
}

.lytable td {
  padding: 2px 4px;
  text-align: left;
  width: 120px;
}
.lytable thead {
  background: #ececec;
  width: calc(100% - 1em);
}
.lytable thead tr,
.lytable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.lytable tbody {
  display: block;
  width: 100%;
  height:calc(100% - 32px);
  overflow-x: scroll;
  overflow-y: scroll;
  padding-top: 10px;
}
.lytable thead {
  display: block;
  width: 100%;
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/lytable.vue